import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import PageTitle from "../../../components/pageTitle/PageTitle.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import TablesForm from "../form/Form.vue";
import chairIcon from "../../../assets/images/chair.png";
export default {
  name: "TablesList.vue",
  components: {
    PageTitle: PageTitle,
    TablesForm: TablesForm
  },
  data: function data() {
    return {
      tables: [],
      showTablesFormPopup: false,
      chairIcon: chairIcon,
      selectedTable: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  mounted: function mounted() {
    this.getTablesList();
  },
  methods: {
    getTablesList: function getTablesList() {
      var _this = this;

      this.$vs.loading();
      providerApiService.getProviderTablesList(this.currentProvider.id).then(function (result) {
        _this.tables = result.data;
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    },
    onTableChanged: function onTableChanged() {
      this.getTablesList();
      this.showTablesFormPopup = false;
    },
    handleOnEditTable: function handleOnEditTable(table) {
      this.showTablesFormPopup = true;
      this.selectedTable = table;
    },
    handleOnDeleteTable: function handleOnDeleteTable(table) {
      var _this2 = this;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "\u062D\u0630\u0641 \u0645\u06CC\u0632",
        text: "\u0622\u06CC\u0627 \u0627\u0632 \u062D\u0630\u0641 \u0645\u06CC\u0632 ".concat(table.title, " \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u062F\u0627\u0631\u06CC\u062F\u061F"),
        acceptText: "بلی",
        cancelText: "خیر",
        accept: function accept() {
          return _this2.deleteTable(table);
        }
      });
    },
    deleteTable: function deleteTable(table) {
      this.$vs.loading();
      providerApiService.deteleTable(this.currentProvider.id, table.id).then(this.getTablesList);
    },
    positionStyle: function positionStyle(total, index) {
      var radius = 85; // Half the width of the circle container

      var angle = 2 * Math.PI / total; // Full circle divided by number of items

      var x = radius + radius * Math.cos(angle * index) - 25; // Adjust 15 for half width of the item

      var y = radius + radius * Math.sin(angle * index) - 25; // Adjust 15 for half height of the item
      // Chairs face towards the center

      var rotation = 90 + 360 / total * index; // Rotate each chair to face the center

      return {
        left: "".concat(x, "px"),
        top: "".concat(y, "px"),
        transform: "translate(-50%, -50%) rotate(".concat(rotation, "deg)")
      };
    },
    tableStyle: function tableStyle(table) {
      var background = "#008854";
      var opacity = 1;

      if (table.isAvailable) {
        background = "#c0c9b7";
        opacity = 0.5;
      } else if (table.isOccupied) {
        background = "#cd4a39";
      } else if (table.isReserved) {
        background = "#0079e6";
      }

      return {
        background: background,
        opacity: opacity
      };
    },
    tableStatus: function tableStatus(table) {
      var text = "فعال است";

      if (table.isAvailable) {
        text = "غیرفعال";
      } else if (table.isOccupied) {
        text = "مشغول است";
      } else if (table.isReserved) {
        text = "رزرو شده";
      }

      return text;
    }
  }
};